module.exports = "images/doc-activity-add-empty-1.9b6380bc90263608057ca1d9d7a1a2c3.png";